/* ProvenGK glove size calculator.
   All sizing rules live in PGK_SIZE_DATA, PGK_UP_RULE, PGK_HALF_SIZE and PGK_SIBLINGS below.
   Edit the data, not the logic. Used by the sizing page and the product page embed. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Data                                                                */
  /* ------------------------------------------------------------------ */

  var PGK_SIZE_DATA = {
    /* Palm length bands in cm. "to" is exclusive, except the top band which
       includes its upper bound. Sizes 4 and 5 are extrapolated on a 1 cm step:
       correct those two rows here after measuring a Junior pair. */
    bands: [
      { size: 4, from: 14.0, to: 15.0 },
      { size: 5, from: 15.0, to: 16.0 },
      { size: 6, from: 16.0, to: 17.0 },
      { size: 7, from: 17.0, to: 18.0 },
      { size: 8, from: 18.0, to: 19.0 },
      { size: 9, from: 19.0, to: 20.0 },
      { size: 10, from: 20.0, to: 21.0 },
      { size: 11, from: 21.0, to: 22.0 }
    ],
    /* Chart palm widths in cm, thumb excluded. 4 to 6 extrapolated on a 0.5 cm step. */
    widths: { 4: 7.0, 5: 7.5, 6: 8.0, 7: 8.5, 8: 9.0, 9: 9.5, 10: 10.0, 11: 10.5 },
    minSize: 4,
    maxSize: 11,
    /* Within this many cm below the top of a band counts as between sizes (whole-size gloves). */
    betweenLengthMargin: 0.25,
    /* Half-size gloves: the upper half of each band is the half size. */
    betweenLengthMarginHalf: 0.5,
    /* Width at or past chart width + this counts as between sizes. */
    wideWidthMargin: 0.5
  };

  /* Gloves that run bigger: between sizes on Standard fit goes up one. */
  var PGK_UP_RULE = ['hybridfusion', 'hybrid-fusion-junior', 'polar-grip-hybrids'];

  /* Gloves sold in half sizes. Between sizes goes to the half size instead of holding;
     Snug rounds down to the whole size, Roomy adds half a size on top of Standard. */
  var PGK_HALF_SIZE = ['enduran'];

  /* Adult <-> Junior siblings, both directions. */
  var PGK_SIBLINGS = {
    'apex': 'apex-junior',
    'provengk-durashield1-0': 'durashield-1-0-junior',
    'provengk-durashield-2-0': 'durashield-2-0-junior',
    'hybridfusion': 'hybrid-fusion-junior',
    'apex-junior': 'apex',
    'durashield-1-0-junior': 'provengk-durashield1-0',
    'durashield-2-0-junior': 'provengk-durashield-2-0',
    'hybrid-fusion-junior': 'hybridfusion'
  };

  var PGK_JUNIOR = ['apex-junior', 'durashield-1-0-junior', 'durashield-2-0-junior', 'hybrid-fusion-junior'];

  /* ------------------------------------------------------------------ */
  /* Logic                                                               */
  /* ------------------------------------------------------------------ */

  /* 'up' (runs bigger), 'half' (sold in half sizes) or 'standard'. */
  function sizeRuleFor(handle) {
    if (PGK_HALF_SIZE.indexOf(handle) !== -1) return 'half';
    return PGK_UP_RULE.indexOf(handle) !== -1 ? 'up' : 'standard';
  }

  /* Returns { state: 'ok'|'below'|'above', size, base, between, byWidth, reason }
     reason: 'default' | 'up-width-roomy' | 'up-roomy' | 'up-model' | 'held-snug' | 'held-standard'
             | 'half-between' | 'half-roomy' */
  function computeSize(lengthCm, widthCm, fit, sizeRule) {
    var d = PGK_SIZE_DATA;
    var bands = d.bands;
    var last = bands[bands.length - 1];

    if (lengthCm < bands[0].from) return { state: 'below' };
    if (lengthCm > last.to) return { state: 'above' };

    var band = null;
    for (var i = 0; i < bands.length; i++) {
      var b = bands[i];
      var isLast = i === bands.length - 1;
      if (lengthCm >= b.from && (lengthCm < b.to || (isLast && lengthCm <= b.to))) { band = b; break; }
    }
    if (!band) return { state: 'above' };

    var base = band.size;
    var isHalf = sizeRule === 'half';
    var margin = isHalf ? d.betweenLengthMarginHalf : d.betweenLengthMargin;
    var byLength = (band.to - lengthCm) <= margin;
    var byWidth = widthCm >= d.widths[base] + d.wideWidthMargin;
    var between = byLength || byWidth;

    var size, reason = 'default';

    if (isHalf) {
      /* Half-size gloves. Standard: whole or half by position in the band.
         Snug: always the whole size. Roomy: Standard plus half a size. */
      var half = between ? 0.5 : 0;
      if (fit === 'roomy') {
        size = base + half + 0.5;
        reason = between ? 'up-roomy' : 'half-roomy';
      } else if (fit === 'snug') {
        size = base;
        reason = between ? 'held-snug' : 'default';
      } else {
        size = base + half;
        reason = between ? 'half-between' : 'default';
      }
      if (size > d.maxSize) { size = d.maxSize; reason = 'default'; }
      if (size < d.minSize) size = d.minSize;
      return { state: 'ok', size: size, base: base, between: between, byWidth: byWidth, reason: reason };
    }

    var up = false;
    if (fit === 'roomy') up = between;
    else if (fit === 'snug') up = false;
    else up = between && sizeRule === 'up';

    size = base + (up ? 1 : 0);
    var clamped = false;
    if (size > d.maxSize) { size = d.maxSize; up = false; clamped = true; }
    if (size < d.minSize) size = d.minSize;

    if (clamped) reason = 'default';
    else if (up && fit === 'roomy' && byWidth) reason = 'up-width-roomy';
    else if (up && fit === 'roomy') reason = 'up-roomy';
    else if (up) reason = 'up-model';
    else if (between && fit === 'snug') reason = 'held-snug';
    else if (between && fit === 'standard' && sizeRule !== 'up') reason = 'held-standard';

    return { state: 'ok', size: size, base: base, between: between, byWidth: byWidth, reason: reason };
  }

  /* "an 8", "an 8.5", "an 11", otherwise "a N". */
  function aSize(n) {
    var whole = Math.floor(n);
    return (whole === 8 || whole === 11 ? 'an ' : 'a ') + n;
  }

  function explain(result, gloveTitle) {
    var n = result.size;
    switch (result.reason) {
      case 'up-width-roomy':
        return "Your palm is on the wide side and you asked for roomy, so we've gone up to " + aSize(n) + '.';
      case 'up-roomy':
        return "Your measurements sit between sizes and you asked for roomy, so we've gone up to " + aSize(n) + '.';
      case 'up-model':
        return 'Your measurements sit between sizes, and the ' + gloveTitle + " runs bigger than our other gloves, so we've gone up to " + aSize(n) + '.';
      case 'half-between':
        return 'Your measurements sit between sizes. The ' + gloveTitle + " comes in half sizes, so we've put you at " + aSize(n) + '.';
      case 'half-roomy':
        return "You asked for roomy, so we've gone up half a size to " + aSize(n) + '.';
      case 'held-snug':
        return "You're between sizes and you like them snug, so we've kept you at " + aSize(n) + '.';
      case 'held-standard':
        return "You're between sizes. Snug beats loose, so we've kept you at " + aSize(n) + '.';
      default:
        return 'Your palm length puts you at ' + aSize(n) + '.';
    }
  }

  /* Exposed for QA in the console. */
  window.PGKSizeCalc = { data: PGK_SIZE_DATA, siblings: PGK_SIBLINGS, upRule: PGK_UP_RULE, halfSize: PGK_HALF_SIZE, computeSize: computeSize, sizeRuleFor: sizeRuleFor };

  /* ------------------------------------------------------------------ */
  /* UI                                                                  */
  /* ------------------------------------------------------------------ */

  var OUT_OF_RANGE_HIGH = "You're above our standard range. Message us with both measurements and we'll sort it. Instagram: @lewis_proven. Email: support@provenclothing.com.";
  var OUT_OF_RANGE_LOW = "That's below our smallest glove. Message us and we'll let you know when a smaller size lands. Instagram: @lewis_proven. Email: support@provenclothing.com.";

  var FIT_NOTES = {
    snug: 'Close to the hand. The pro fit.',
    standard: 'Our recommended fit for most keepers.',
    roomy: 'A little more finger space.'
  };

  function round1(n) { return Math.round(n * 10) / 10; }

  function parseNum(str) {
    if (typeof str !== 'string') return NaN;
    var s = str.replace(',', '.').trim();
    if (s === '') return NaN;
    var n = Number(s);
    return isFinite(n) && n > 0 ? n : NaN;
  }

  function cssEscape(s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/([^a-zA-Z0-9_-])/g, '\\$1');
  }

  function initCalculator(root) {
    var cfg = {
      context: root.getAttribute('data-context') || 'page',
      source: root.getAttribute('data-source') || 'sizing_page',
      company: root.getAttribute('data-company') || '',
      list: root.getAttribute('data-list') || '',
      preselect: root.getAttribute('data-preselect') || '',
      formId: root.getAttribute('data-form-id') || '',
      sizePos: root.getAttribute('data-size-pos') || ''
    };

    var map = {};
    try {
      var mapEl = root.querySelector('script[data-glove-map]');
      if (mapEl) map = JSON.parse(mapEl.textContent);
    } catch (e) { map = {}; }

    var els = {
      gloveStep: root.querySelector('[data-step-gloves]'),
      gloveGrid: root.querySelector('[data-glove-grid]'),
      gloveSummary: root.querySelector('[data-glove-summary]'),
      gloveSummaryName: root.querySelector('[data-glove-summary-name]'),
      gloveChange: root.querySelector('[data-glove-change]'),
      width: root.querySelector('[data-input-width]'),
      length: root.querySelector('[data-input-length]'),
      errWidth: root.querySelector('[data-error-width]'),
      errLength: root.querySelector('[data-error-length]'),
      unitLabels: root.querySelectorAll('[data-unit-label]'),
      fitNote: root.querySelector('[data-fit-note]'),
      result: root.querySelector('[data-result]'),
      resultSize: root.querySelector('[data-result-size]'),
      resultGlove: root.querySelector('[data-result-glove]'),
      resultExplain: root.querySelector('[data-result-explain]'),
      resultNote: root.querySelector('[data-result-note]'),
      resultAction: root.querySelector('[data-result-action]'),
      resultAlts: root.querySelector('[data-result-alts]'),
      emailForm: root.querySelector('[data-email-form]'),
      emailError: root.querySelector('[data-email-error]')
    };

    var state = {
      glove: cfg.context === 'product' ? cfg.preselect : null,
      unit: 'cm',
      fit: 'standard',
      shown: false,
      lastResult: null
    };

    var track = { timer: null, lastKey: '', lastPayload: null };

    var PLACEHOLDERS = { cm: { width: 'e.g. 9.5', length: 'e.g. 20.5' }, in: { width: 'e.g. 3.7', length: 'e.g. 8.1' } };

    /* ---------------- Step 1: glove picker (page context) ---------------- */

    function selectedGlove() { return state.glove && map[state.glove] ? map[state.glove] : null; }

    function setGlove(handle, collapse) {
      state.glove = handle && map[handle] ? handle : null;
      if (els.gloveGrid) {
        var radios = els.gloveGrid.querySelectorAll('input[name="pgk-glove"]');
        for (var i = 0; i < radios.length; i++) {
          radios[i].checked = radios[i].value === state.glove;
          var card = radios[i].closest('.pgk-sc__glove-card');
          if (card) card.classList.toggle('is-selected', radios[i].checked);
        }
      }
      if (collapse && state.glove && els.gloveSummary && els.gloveGrid) {
        els.gloveSummaryName.textContent = map[state.glove].title;
        els.gloveSummary.hidden = false;
        els.gloveGrid.hidden = true;
      }
      recompute(true);
    }

    if (els.gloveGrid) {
      els.gloveGrid.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'pgk-glove') setGlove(e.target.value, false);
      });
    }
    if (els.gloveChange) {
      els.gloveChange.addEventListener('click', function () {
        els.gloveSummary.hidden = true;
        els.gloveGrid.hidden = false;
      });
    }

    if (cfg.context === 'page') {
      try {
        var param = new URLSearchParams(window.location.search).get('glove');
        if (param && map[param]) setGlove(param, true);
      } catch (e) { /* ignore */ }
    }

    /* ---------------- Units ---------------- */

    function applyUnit(unit) {
      var prev = state.unit;
      if (unit === prev) return;
      state.unit = unit;
      var fields = [els.width, els.length];
      for (var i = 0; i < fields.length; i++) {
        var v = parseNum(fields[i].value);
        if (!isNaN(v)) {
          fields[i].value = String(unit === 'in' ? round1(v / 2.54) : round1(v * 2.54));
        }
        fields[i].placeholder = PLACEHOLDERS[unit][i === 0 ? 'width' : 'length'];
      }
      for (var j = 0; j < els.unitLabels.length; j++) els.unitLabels[j].textContent = '(' + unit + ')';
      recompute(false);
    }

    var unitRadios = root.querySelectorAll('input[name="pgk-unit"]');
    for (var u = 0; u < unitRadios.length; u++) {
      unitRadios[u].addEventListener('change', function (e) { applyUnit(e.target.value); });
    }

    /* ---------------- Fit chips ---------------- */

    var fitRadios = root.querySelectorAll('input[name="pgk-fit"]');
    for (var f = 0; f < fitRadios.length; f++) {
      fitRadios[f].addEventListener('change', function (e) {
        state.fit = e.target.value;
        if (els.fitNote) els.fitNote.textContent = FIT_NOTES[state.fit] || '';
        recompute(true);
      });
    }

    /* ---------------- Inputs ---------------- */

    function readCm(input) {
      var v = parseNum(input.value);
      if (isNaN(v)) return NaN;
      return state.unit === 'in' ? round1(v * 2.54) : v;
    }

    function validate() {
      var wRaw = els.width.value.trim();
      var lRaw = els.length.value.trim();
      var w = readCm(els.width);
      var l = readCm(els.length);
      var anyTyped = wRaw !== '' || lRaw !== '';

      setError(els.errWidth, wRaw !== '' && isNaN(w) ? "That's not a number." : (wRaw === '' && lRaw !== '' && !isNaN(l) ? 'Add your palm width.' : ''));
      setError(els.errLength, lRaw !== '' && isNaN(l) ? "That's not a number." : (lRaw === '' && wRaw !== '' && !isNaN(w) ? 'Add your palm length.' : ''));

      return { valid: !isNaN(w) && !isNaN(l), widthCm: w, lengthCm: l, anyTyped: anyTyped };
    }

    function setError(el, msg) {
      if (!el) return;
      el.textContent = msg;
      el.hidden = msg === '';
    }

    /* Wrapped so the Event object is not mistaken for the `immediate` flag. */
    els.width.addEventListener('input', function () { recompute(false); });
    els.length.addEventListener('input', function () { recompute(false); });

    /* ---------------- Result rendering ---------------- */

    function clearNode(el) { while (el.firstChild) el.removeChild(el.firstChild); }

    function firstInStock(entries) {
      for (var i = 0; i < entries.length; i++) if (entries[i].available) return entries[i];
      return null;
    }

    function makeButton(text, href) {
      var el;
      if (href) {
        el = document.createElement('a');
        el.href = href;
      } else {
        el = document.createElement('button');
        el.type = 'button';
      }
      el.className = 'pgk-sc__button';
      el.textContent = text;
      return el;
    }

    function renderResult(res, widthCm, lengthCm) {
      var card = els.result;
      var glove = selectedGlove();
      var title = glove ? glove.title : null;

      card.hidden = false;
      els.resultNote.hidden = true;
      els.resultNote.textContent = '';
      els.resultAlts.hidden = true;
      clearNode(els.resultAlts);
      clearNode(els.resultAction);

      if (res.state !== 'ok') {
        els.resultSize.hidden = true;
        els.resultGlove.hidden = true;
        els.resultExplain.textContent = res.state === 'above' ? OUT_OF_RANGE_HIGH : OUT_OF_RANGE_LOW;
        if (els.emailForm) els.emailForm.hidden = true;
        return;
      }

      var n = res.size;
      var sizeKey = String(n);

      els.resultSize.hidden = false;
      els.resultSize.textContent = n;
      els.resultGlove.hidden = !title;
      if (title) els.resultGlove.textContent = title;
      els.resultExplain.textContent = explain(res, title || '');
      if (els.emailForm) els.emailForm.hidden = false;

      if (!glove) {
        var pick = document.createElement('p');
        pick.className = 'pgk-sc__pick-note';
        pick.textContent = 'Pick a glove above to get a link to the right size.';
        els.resultAction.appendChild(pick);
        return;
      }

      var entries = glove.variants[sizeKey];

      if (entries && entries.length) {
        if (cfg.context === 'product') {
          var stocked = firstInStock(entries);
          var btn = makeButton(stocked ? 'Get the ' + title + ' in size ' + n : 'Size ' + n + ' is out of stock', null);
          btn.addEventListener('click', function () { selectSizeInForm(sizeKey); });
          els.resultAction.appendChild(btn);
          if (glove.hasColour) note('Choose your colour above.');
        } else {
          var inStock = firstInStock(entries);
          if (inStock) {
            els.resultAction.appendChild(makeButton('Get the ' + title + ' in size ' + n, inStock.url));
            if (glove.hasColour && entries.length > 1) note('Choose colour on the next page.');
          } else {
            els.resultAction.appendChild(makeButton('Size ' + n + ' is out of stock. Notify me', glove.url));
          }
        }
        return;
      }

      /* Sibling routing: adult <-> junior */
      var sibHandle = PGK_SIBLINGS[state.glove];
      var sib = sibHandle && map[sibHandle] ? map[sibHandle] : null;
      var sibEntries = sib ? sib.variants[sizeKey] : null;

      if (sib && sibEntries && sibEntries.length) {
        var sibJunior = PGK_JUNIOR.indexOf(sibHandle) !== -1;
        note(sibJunior
          ? 'Size ' + n + ' is in the Junior range. Same glove, same chart.'
          : 'Size ' + n + ' is in the adult range.');
        var sibStock = firstInStock(sibEntries);
        if (sibStock) {
          els.resultAction.appendChild(makeButton('Get the ' + sib.title + ' in size ' + n, sibStock.url));
          if (sib.hasColour && sibEntries.length > 1) note2('Choose colour on the next page.');
        } else {
          els.resultAction.appendChild(makeButton('Size ' + n + ' is out of stock. Notify me', sib.url));
        }
        return;
      }

      /* No product in this line stocks the size: offer everything that does.
         A half size nobody else makes falls back to the whole size below it. */
      var altKey = (n % 1 === 0) ? sizeKey : String(Math.floor(n));
      note("We don't make the " + title + ' in ' + aSize(n) + " yet. Here's what we do make in your size:");
      var any = false;
      for (var h in map) {
        if (!Object.prototype.hasOwnProperty.call(map, h)) continue;
        var e2 = map[h].variants[altKey];
        if (e2 && e2.length) {
          var s2 = firstInStock(e2);
          var link = document.createElement('a');
          link.href = s2 ? s2.url : map[h].url;
          link.textContent = map[h].title + (s2 ? '' : ' (out of stock)');
          els.resultAlts.appendChild(link);
          any = true;
        }
      }
      els.resultAlts.hidden = !any;
      if (!any) note2('Nothing in stock in ' + aSize(n) + ' right now. Message us and we will sort it.');

      function note(t) { els.resultNote.hidden = false; els.resultNote.textContent = t; }
      function note2(t) {
        var p = document.createElement('p');
        p.className = 'pgk-sc__result-subnote';
        p.textContent = t;
        els.resultAction.appendChild(p);
      }
    }

    function selectSizeInForm(sizeStr) {
      if (!cfg.formId || !cfg.sizePos) return;
      var name = cfg.formId + '-option' + cfg.sizePos;
      var radios = document.querySelectorAll('input[type="radio"][name="' + cssEscape(name) + '"]');
      for (var i = 0; i < radios.length; i++) {
        var label = radios[i].id ? document.querySelector('label[for="' + cssEscape(radios[i].id) + '"]') : null;
        var txt = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
        if (txt === sizeStr) {
          if (!radios[i].checked) radios[i].click();
          scrollToAtc();
          return;
        }
      }
    }

    function scrollToAtc() {
      var sels = [
        'button[name="add"][form="' + cssEscape(cfg.formId) + '"]',
        '#' + cssEscape(cfg.formId) + ' button[name="add"]',
        'button[name="add"]'
      ];
      for (var i = 0; i < sels.length; i++) {
        var el = document.querySelector(sels[i]);
        if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      }
    }

    /* ---------------- Klaviyo ---------------- */

    function fireIfChanged(key, payload) {
      if (key === track.lastKey) return;
      track.lastKey = key;
      pushTrack(payload);
    }

    /* Debounce keystroke-driven recomputes; discrete choices (glove, fit) fire
       immediately so the glove is never missing from the event. */
    function scheduleTrack(res, widthCm, lengthCm, immediate) {
      var glove = selectedGlove();
      var key = res.size + '|' + (state.glove || '');
      var payload = {
        glove_model: glove ? glove.title : 'none',
        glove_handle: state.glove || '',
        recommended_size: res.size,
        fit_preference: state.fit,
        palm_length_cm: round1(lengthCm),
        palm_width_cm: round1(widthCm),
        source: cfg.source
      };
      track.lastPayload = payload;
      if (track.timer) clearTimeout(track.timer);
      if (immediate) {
        fireIfChanged(key, payload);
        return;
      }
      track.timer = setTimeout(function () { fireIfChanged(key, payload); }, 800);
    }

    /* Anonymous pushes are queued in the browser by klaviyo.js and only sent
       once the visitor identifies (verified 01-09-2026); never-identified
       visits are not counted in Klaviyo. */
    function pushTrack(payload) {
      if (!window.klaviyo) return;
      try {
        window.klaviyo.push(['track', 'Used Size Calculator', payload]);
      } catch (e) { /* ignore */ }
    }

    /* ---------------- Email capture ---------------- */

    if (els.emailForm) {
      els.emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = els.emailForm.querySelector('input[type="email"]');
        var email = input ? input.value.trim() : '';
        setError(els.emailError, '');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setError(els.emailError, 'Enter a valid email address.');
          return;
        }
        var res = state.lastResult;
        if (!res || res.state !== 'ok') {
          setError(els.emailError, 'Add your measurements first so we know your size.');
          return;
        }
        var glove = selectedGlove();
        var btn = els.emailForm.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;

        var body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'size_calculator',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      glove_size: res.size,
                      glove_model: glove ? glove.title : 'none',
                      fit_preference: state.fit,
                      signup_source: 'size_calculator'
                    }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: cfg.list } } }
          }
        };

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(body)
        }).then(function (resp) {
          if (!resp.ok) throw new Error('subscribe failed');
          els.emailForm.innerHTML = '<p class="pgk-sc__email-done">Done. Your size is on its way.</p>';
          try {
            if (window.klaviyo) window.klaviyo.push(['identify', { $email: email }]);
          } catch (err) { /* ignore */ }
          if (track.lastPayload) pushTrack(track.lastPayload);
        }).catch(function () {
          if (btn) btn.disabled = false;
          setError(els.emailError, "That didn't go through. Try again in a minute.");
        });
      });
    }

    /* ---------------- Recompute ---------------- */

    function recompute(immediate) {
      var v = validate();
      if (!v.valid) {
        els.result.hidden = true;
        state.shown = false;
        state.lastResult = null;
        return;
      }
      var glove = selectedGlove();
      var rule = glove ? sizeRuleFor(state.glove) : 'standard';
      var res = computeSize(v.lengthCm, v.widthCm, state.fit, rule);
      state.lastResult = res;
      renderResult(res, v.widthCm, v.lengthCm);
      if (!state.shown) {
        state.shown = true;
        try { els.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) { /* ignore */ }
      }
      if (res.state === 'ok') scheduleTrack(res, v.widthCm, v.lengthCm, immediate === true);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-pgk-sizecalc]:not([data-pgk-init])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-pgk-init', '');
      try { initCalculator(roots[i]); } catch (e) { /* leave server-rendered content usable */ }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
